import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Info } from "../../../../assets/icons/info.svg";
import * as FileSaver from "file-saver";
import { useHistory, useLocation, useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import {
  converTime,
  getCallStatusData,
  isEmpty,
  LoadingSlides,
  PAGE_SIZE_50,
} from "../../CommonComponents/Common";
import {
  getAllCampaignDetailsAction,
  exportAllCampaignRunsAction,
} from "../../ProjectSection/CampaignSection/Store/Campaign.action";
import CommonModal from "../../CommonComponents/Modal/CommonModal";
import Insight from "../CampaignDetails/Insight";
import SummaryCard from "../Campaign/SummaryCards";
import FilterBody from "../../../../common/components/Filter/FilterBody";
import DynamicTable from "../../CommonComponents/Table/DynamicTable";
import StatusButton from "../../Common/Buttons/StatusButton";
import BaseButton from "../../Common/Buttons/BaseButton";
import CallTranscriptModal from "../../CallHistory/CallTranscriptModal";
import SearchBar from "../../Common/Search/SearchBar";
import useDebounce from "../../../Hooks/useDebounce";
import ReactAudioPlayer from "react-audio-player";

import { ReactComponent as MenuDots } from "../../../../assets/Images/MenuDots.svg";
import { ReactComponent as BackIcon } from "../../../../assets/Images/WhiteBackIcon.svg";
import { ReactComponent as FilterIcon } from "../../../../assets/Images/FilterIcon.svg";
import { ReactComponent as ExportIcon } from "../../../../assets/icons/export.svg";
import { styles } from "../../../../assets/MUIStyles/campaignDetailsList";
import {
  getDecryptedItem,
  setEncryptedItem,
} from "../../../../utils/localStorageHelper";
import { commonStyles } from "../../../../assets/MUIStyles/commonStyles";
import PageLoader from "../../CommonComponents/PageLoader";
import { Bot, User } from "lucide-react";

function AllCampaignRuns() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { projectId } = useParams<{ projectId: string }>();
  const location = useLocation();
  const locSearch = new URLSearchParams(location.search);
  const campaignRuns = locSearch.get("campaignRuns");
  const campaignId = locSearch.get("campaign-id");
  const trunk = locSearch.get("trunk");
  const [loading, setLoading] = useState(false);
  const reducer: any = useSelector((state) => state);

  const {
    AccountReducer: { constantData },
    CampaignReducer: {
      allcampaignsDetails,
      allcampaignsDetailsCounts,
      allcampaignsDetailsTotalCounts,
    },
  } = reducer;
  const appliedFiltersLoc = getDecryptedItem("allCampaignRunsFilters") || {};
  const menuButtonRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const [state, setState] = useState<any>({
    CALL_STATUS: constantData?.callStatus,
    campaignRunListData: [],
    showCreateButton: false,
    exportSpin: false,
    summaryModal: false,
    recordingUrl: "",
    selectedCampaignRun: "",
    filterDrawer: false,
    countObj: {},
    insightsPopupView: false,
    trackEnabledRecording: [],
    pageIndex: Number(getDecryptedItem("allcampaignrunspageIndex")) || 1,
    durationFilter: appliedFiltersLoc?.durationFilter || "",
    outComefilter: appliedFiltersLoc?.outcomeFilters || [],
    statusFilter: appliedFiltersLoc?.statusFilter || [],
    searchText: "",
    min: appliedFiltersLoc?.customFilter
      ? appliedFiltersLoc?.customFilter.split("-")[0] || ""
      : "",
    max: appliedFiltersLoc?.customFilter
      ? appliedFiltersLoc?.customFilter.split("-")[1] || ""
      : "",
  });
  const {
    campaignRunListData,
    selectedCampaignRun,
    exportSpin,
    summaryModal,
    filterDrawer,
    countObj,
    insightsPopupView,
    trackEnabledRecording,
    pageIndex,
    durationFilter,
    statusFilter,
    outComefilter,
    CALL_STATUS,
    searchText,
  } = state;
  const [anchorEl, setAnchorEl] = useState(null);

  const debouncedSearchTerm = useDebounce(searchText, 3000);

  const {
    AccountReducer: { selectedAccount },
    RecordingReducer: { recordings },
  } = reducer;

  const callFn = async (searchTerm = "") => {
    setLoading(true);

    const obj = {
      pageIndex: pageIndex,
      pageSize: PAGE_SIZE_50,
      live: false,
      duration:
        durationFilter === "Custom"
          ? `${state?.min}-${state?.max}`
          : durationFilter?.split(" ")[0],
      callStatus: statusFilter,
      outcome: outComefilter,
      searchText: searchTerm,
    };

    await dispatch(
      getAllCampaignDetailsAction(campaignId, { ...obj, isDocsOnly: "true" })
    );
    setLoading(false);
    await dispatch(
      getAllCampaignDetailsAction(campaignId, { ...obj, isDocsOnly: false })
    );
  };

  useEffect(() => {
    callFn(debouncedSearchTerm);
  }, [dispatch, debouncedSearchTerm]);

  useEffect(() => {
    if (allcampaignsDetails) {
      setState((prev) => ({
        ...prev,
        campaignRunListData: allcampaignsDetails,
      }));
    }
  }, [allcampaignsDetails]);
  useEffect(() => {
    if (allcampaignsDetailsCounts?.length > 0) {
      let countsData = {};

      for (const status of allcampaignsDetailsCounts) {
        countsData[status._id] = status.count;
      }
      setState((prev) => ({
        ...prev,
        countObj: countsData,
      }));
    }
  }, [allcampaignsDetailsCounts]);

  useEffect(() => {
    if (recordings?.length > 0) {
      let arr: any = [];
      for (const record of recordings) {
        if (record?.track === true) {
          arr.push({
            name: record.recordingName,
            tag: record.tag,
          });
        }
      }
      setState((prev) => ({
        ...prev,
        trackEnabledRecording: arr,
      }));
    }
  }, [recordings]);

  const toggle = (name = "summaryModal") => {
    setState((prev) => ({
      ...prev,
      [name]: !prev[name],
      durationFilter: appliedFiltersLoc?.durationFilter || "",
      outComefilter: appliedFiltersLoc?.outcomeFilters || [],
      statusFilter: appliedFiltersLoc?.statusFilter || [],
      searchText: "",
      min: appliedFiltersLoc?.customFilter
        ? appliedFiltersLoc?.customFilter.split("-")[0] || ""
        : "",
      max: appliedFiltersLoc?.customFilter
        ? appliedFiltersLoc?.customFilter.split("-")[1] || ""
        : "",
    }));
  };

  const getOutcome = (data) => {
    let trackResult: any = [];
    if (data?.outComes) {
      data.outComes.forEach((da) => {
        let kl = trackEnabledRecording.find((kl) => kl.tag === da);
        if (kl) {
          trackResult.push(kl.name);
        }
      });

      trackEnabledRecording?.forEach((track) => {
        if (data.outComes.includes(track.tag)) {
          trackResult.push(track.name);
        }
      });
      return trackResult.length > 0 ? trackResult[trackResult?.length - 1] : "";
    } else {
      return "";
    }
  };
  const getName = (phone) => {
    const firstName = phone?.customParameters?.firstName;
    const lastName = phone?.customParameters?.lastName;
    if (firstName || lastName) {
      return `${firstName || ""}${lastName || ""}`.trim();
    }
    return "No Name";
  };

  const openModal = (selectedCampaignRun) => {
    setState((prev) => ({
      ...prev,
      summaryModal: true,
      recordingUrl: selectedCampaignRun.recordingUrl,
      selectedCampaignRun: selectedCampaignRun,
    }));
  };

  const ExportCSV = async () => {
    setState((prev) => ({
      ...prev,
      exportSpin: true,
    }));

    let obj = {
      pageIndex: 1,
      pageSize: 1000,
      live: false,
      duration:
        durationFilter === "Custom"
          ? `${state?.min}-${state?.max}`
          : durationFilter?.split(" ")[0],
      callStatus: statusFilter,
      outcome: outComefilter,
      searchText: searchText,
      isDocsOnly: "true",
    };
    let res: any = await dispatch(exportAllCampaignRunsAction(campaignId, obj));

    let matchArr = [
      "mandatory_params",
      "firstName",
      "lastName",
      "FirstName",
      "LastName",
      "phone",
      "PhoneNum",
    ];
    if (res) {
      let arr: any = [];
      res.forEach((kl) => {
        let copy = kl?.customParameters;
        let obj: any = {};
        obj["First Name"] = copy?.FirstName || "--";
        obj["Last Name"] = copy?.LastName || "--";
        obj["Phone number"] = kl?.phone || "--";
        obj["Calling Status"] = CALL_STATUS[kl.callStatus] || "";
        obj["Call UUID"] = kl?.call_uuid || "";
        obj["Cost"] = kl?.newCost || "";
        if (selectedAccount?.params?.pricesWaivers) {
          obj["Cost"] = "--";
        }
        obj["Recording Url"] = kl?.callRecordingUrl || "";
        if (!isEmpty(copy)) {
          for (const customKeys in copy) {
            if (!matchArr.includes(customKeys)) {
              obj[customKeys] = copy[customKeys];
            }
          }
        }

        arr.push(obj);
      });
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arr);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, `Campaign Report ` + fileExtension);
    }
    setState((prev) => ({
      ...prev,
      exportSpin: false,
    }));
  };

  const obj = {
    projectId,
    searchText,
    setMainState: setState,
    trackEnabledRecording,
    mainState: state,
    campaignRuns,
    campaignId,
  };

  const handlePageNextInScroll = async (index) => {
    let obj = {
      pageIndex: index,
      pageSize: PAGE_SIZE_50,
      live: false,
      duration:
        durationFilter === "Custom"
          ? `${state?.min}-${state?.max}`
          : durationFilter?.split(" ")[0],
      callStatus: statusFilter,
      outcome: outComefilter,
      isScrolled: false,
      searchText: searchText,
    };
    await dispatch(
      getAllCampaignDetailsAction(campaignId, { ...obj, isDocsOnly: "true" })
    );
    setState((prev) => ({
      ...prev,
      pageIndex: index,
    }));
    setEncryptedItem("allcampaignrunspageIndex", index);
  };

  const closeInsightsModal = () => {
    setState((prev) => ({
      ...prev,
      insightsPopupView: false,
      durationFilter: appliedFiltersLoc?.durationFilter || "",
      outComefilter: appliedFiltersLoc?.outcomeFilters || [],
      statusFilter: appliedFiltersLoc?.statusFilter || [],
      searchText: "",
      min: appliedFiltersLoc?.customFilter
        ? appliedFiltersLoc?.customFilter.split("-")[0] || ""
        : "",
      max: appliedFiltersLoc?.customFilter
        ? appliedFiltersLoc?.customFilter.split("-")[1] || ""
        : "",
    }));

    callFn(searchText);
  };

  if (loading) {
    return <PageLoader height="90vh" />;
  }

  return (
    <>
      <Box
        className="flex-between header"
        sx={{
          gap: 1,
        }}
      >
        <Box
          className="flex-align-center"
          sx={{
            gap: 1,
          }}
        >
          <Typography className="font-20-grey">Campaign List</Typography>
        </Box>

        <Box
          className="flex-align-center"
          sx={{
            gap: 1,
          }}
        >
          <SearchBar
            searchText={searchText}
            handleChange={(e) => {
              e.persist();
              setState((prev) => ({
                ...prev,
                searchText: e.target.value,
              }));
            }}
          />
          <Box display="inline-block" position="relative">
            <Box ref={menuButtonRef}>
              <BaseButton
                title={<MenuDots title="More" />}
                variant="outlined"
                handleClick={() => setMenuOpen(true)}
                styles={styles.iconBtn}
              />
            </Box>
            <Menu
              id="simple-menu"
              anchorEl={menuButtonRef.current}
              open={menuOpen}
              onClose={() => setMenuOpen(false)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              slotProps={{
                paper: {
                  sx: styles.menu,
                },
              }}
            >
              <MenuItem
                sx={styles.menuItem}
                onClick={() => {
                  setState((prev) => ({
                    ...prev,
                    insightsPopupView: true,
                  }));
                  setMenuOpen(false);
                }}
              >
                View Insight
              </MenuItem>
              <MenuItem sx={styles.menuItem} onClick={ExportCSV}>
                <ExportIcon />
                <Typography
                  className="font-14-grey3"
                  sx={{
                    ml: 1.2,
                  }}
                >
                  Export File
                </Typography>
              </MenuItem>
            </Menu>
          </Box>

          <BaseButton
            title={<FilterIcon title="Apply Filters" />}
            variant="outlined"
            handleClick={() => toggle("filterDrawer")}
            styles={styles.iconBtn}
          />

          <BaseButton
            title="Back"
            variant="contained"
            handleClick={() =>
              history.push(
                `/account/project/${projectId}/campaign-runs?campaignid=${campaignId}`
              )
            }
            startIcon={<BackIcon className="back-icon" />}
          />
        </Box>
      </Box>
      <Box sx={commonStyles.summaryCardContainer}>
        <SummaryCard
          title="Calls Failed"
          value={countObj["704"] || 0}
          circleColor="linear-gradient(180deg, rgba(255, 150, 143, 0.8) 0%, rgba(226, 76, 66, 0.8) 100%)"
        />
        <SummaryCard
          title="Calls Connected"
          value={countObj["703"] || 0}
          circleColor="linear-gradient(237.96deg, rgba(150, 255, 143, 0.8) -12.91%, rgba(87, 209, 78, 0.8) 100.74%)"
        />
        <SummaryCard
          title=" Calls Made"
          value={allcampaignsDetailsTotalCounts || 0}
          circleColor="linear-gradient(122.19deg, rgba(255, 143, 224, 0.8) 34.92%, rgba(242, 93, 203, 0.8) 100.02%)"
        />
      </Box>
      <Box
        sx={{
          mb: 2,
        }}
      >
        <DynamicTable
          columns={[
            {
              label: "Phone Number",
              render: (campaign) => {
                return (
                  <Tooltip
                    slotProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "#111111",
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#111111",
                        },
                      },
                    }}
                    title={getName(campaign)}
                    placement="right"
                    arrow
                  >
                    <span> {campaign.phone}</span>
                  </Tooltip>
                );
              },
            },
            {
              label: "Call Status | Ended By",
              render: (row) => {
                const statusData = getCallStatusData(
                  row?.callStatus,
                  constantData
                );
                return (
                  <Box className="flex-xy-center" gap={1} mr={5}>
                    <StatusButton
                      status={statusData?.status}
                      statusColor={statusData?.statusColor}
                      backgroundColor={statusData?.backgroundColor}
                      statusDescription={statusData?.statusDescription}
                    />
                    <Divider orientation="vertical" flexItem />

                    {row?.bot_dropped == null ? (
                      "--"
                    ) : row?.bot_dropped ? (
                      <Tooltip title="Call Ended by Bot">
                        <Bot color="rgba(0, 0, 0, 0.5)" size={20} />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Call Ended by Human">
                        <User color="rgba(0, 0, 0, 0.5)" size={20} />
                      </Tooltip>
                    )}
                  </Box>
                );
              },
            },
            {
              label: trackEnabledRecording?.length > 0 ? "Outcomes" : "UUID",
              render: (campaign) =>
                trackEnabledRecording?.length > 0
                  ? getOutcome(campaign)
                  : campaign?.call_uuid && (
                      <Tooltip
                        slotProps={{
                          tooltip: {
                            sx: commonStyles.popoverCard.mainContainer,
                          },
                        }}
                        title={
                          <Box sx={{ width: 270 }}>
                            <Typography
                              variant="subtitle1"
                              fontWeight="bold"
                              sx={{
                                p: 1.5,
                                borderBottom: "1px solid #e0e0e0",
                                bgcolor: "#f5f5f5",
                              }}
                            >
                              Call Information
                            </Typography>
                            <Box sx={{ p: 1.5 }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }}
                              >
                                Call Reference Id:{" "}
                                <strong>{campaign?.call_uuid}</strong>
                              </Typography>
                            </Box>
                          </Box>
                        }
                        placement="right"
                        arrow
                        enterDelay={300}
                        leaveDelay={200}
                      >
                        <IconButton>
                          <Info title="UUID" />
                        </IconButton>
                      </Tooltip>
                    ),
            },
            {
              label: "Call Cost",
              render: ({ newCost }) =>
                selectedAccount?.params?.pricesWaivers ? "--" : newCost || "--",
            },

            {
              label: "Call Summary",
              render: (campaign) => {
                return (
                  <BaseButton
                    disabled={!["703", "712"].includes(campaign?.callStatus)}
                    title="View Transcript"
                    handleClick={() => openModal(campaign)}
                    styles={{ color: "#4280FF" }}
                  />
                );
              },
            },

            {
              label: "Recording",
              render: ({ callRecordingUrl, call_uuid }) => {
                return (
                  <ReactAudioPlayer
                    src={
                      callRecordingUrl ||
                      `https://storage.googleapis.com/botstream-recordings/${call_uuid}.mp3`
                    }
                    controls
                    style={{
                      maxWidth: "250px",
                      height: "30px",
                    }}
                  />
                );
              },
            },
            trunk === "show"
              ? {
                  label: "Trunk Status | Trunk Status Code",
                  render: (row) => {
                    return (
                      <Box className="flex-xy-center" gap={0.5} mr={10}>
                        <Typography className="font-12-mediumgrey">
                          {row?.pbx_statustext || "--"}
                        </Typography>
                        <Divider orientation="vertical" flexItem />
                        <Typography className="font-12-mediumgrey">
                          {row?.pbx_statuscode || "--"}
                        </Typography>
                      </Box>
                    );
                  },
                }
              : null,
            {
              label: "Campaign Run Time",
              render: ({ createdAt }) => converTime(createdAt),
              styles: { textTransform: "none" },
            },
          ]?.filter(Boolean)}
          data={campaignRunListData}
          loading={loading}
          totalPages={Math.ceil(
            Number(allcampaignsDetailsTotalCounts) / PAGE_SIZE_50
          )}
          currentPage={Number(pageIndex)}
          handlePageChange={(e, v) => {
            handlePageNextInScroll(v);
          }}
          handlePrevious={() => handlePageNextInScroll(pageIndex - 1)}
          handleNext={() => handlePageNextInScroll(pageIndex + 1)}
          noDataAvailableMessage="No Campaigns Available"
          rowCount={campaignRunListData?.length}
          totalRowCount={allcampaignsDetailsTotalCounts}
        />
      </Box>

      {filterDrawer && (
        <Drawer
          anchor={"right"}
          open={filterDrawer}
          onClose={() => toggle("filterDrawer")}
        >
          <FilterBody
            obj={obj}
            encryptionKey="allCampaignRunsFilters"
            showSection={false}
            main={false}
            all={true}
          />
        </Drawer>
      )}

      {summaryModal && (
        <CallTranscriptModal
          show={summaryModal}
          onClose={() => toggle("summaryModal")}
          selectedTranscript={selectedCampaignRun}
        />
      )}

      {insightsPopupView && (
        <CommonModal
          show={insightsPopupView}
          toggle={closeInsightsModal}
          size={900}
          handleSave={() => {}}
          heading="View Insight"
          body={<Insight campaignName={""} all={true} />}
        />
      )}
    </>
  );
}

export default AllCampaignRuns;
